import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../utils/helpers/model.helper';
import { BannersCanvases } from './sub-models/banners-canvases.model';
import { Features } from './sub-models/features.model';
import { ProvisioningSubscription } from './sub-models/provisioning-subscription.model';

export const PROVISIONING_FEATURES_SCHEMA = Object.freeze({
  SUBSCRIPTION: ProvisioningSubscription,
  FEATURES: Features,
  BANNERS_AND_CANVASES: BannersCanvases,
});

const RECORD = generateSchema(PROVISIONING_FEATURES_SCHEMA);
const KEYS: any = generateKeys(PROVISIONING_FEATURES_SCHEMA);

export class ProvisioningFeatures extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.SUBSCRIPTION,
        value: new ProvisioningSubscription(this.subscription),
      },
      {
        key: KEYS.FEATURES,
        value: new Features(this.features),
      },
      {
        key: KEYS.BANNERS_AND_CANVASES,
        value: new BannersCanvases(this.bannersCanvases),
      },
    ]);

    return selfModel as ProvisioningFeatures;
  }

  get subscription(): ProvisioningSubscription {
    return this.get(KEYS.SUBSCRIPTION);
  }

  get features(): Features {
    return this.get(KEYS.FEATURES);
  }

  get bannersCanvases(): BannersCanvases {
    return this.get(KEYS.BANNERS_AND_CANVASES);
  }
}
